<dialog #dialog class="rdlg" (close)="onClosed()">
  @if (target(); as s) {
    <header class="rdlg__head">
      <div>
        <p class="rdlg__eyebrow">{{ 'INSPECTION.REPORT_FOR' | translate }}</p>
        <h2 class="rdlg__title">{{ s.title }}</h2>
        <p class="rdlg__meta">
          {{ s.scheduledDate | date:'dd/MM/yyyy' }} · {{ s.consultantName }}
          @if (subjectsOf(s)) { · {{ subjectsOf(s) }} }
        </p>
      </div>
      <button type="button" class="rdlg__close" (click)="close()"
              [attr.aria-label]="'ACTIONS.CLOSE' | translate">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </header>

    <!-- Le message reste dans la modale, en tête : une alerte flottante y
         serait peinte au-dessus sans jamais recevoir le clic. -->
    @if (error()) {
      <p class="rdlg__alert" role="alert">
        <i class="fa-solid fa-circle-exclamation"></i>
        <span>{{ error()! | translate }}</span>
      </p>
    }

    <div class="rdlg__body">
      <quill-editor [(ngModel)]="report"
                    [modules]="editorModules"
                    [placeholder]="'INSPECTION.REPORT_PLACEHOLDER' | translate"
                    theme="snow"></quill-editor>

      <!-- ─── Pièces jointes ───────────────────────────────────────────
           Les pièces déjà déposées se retirent une à une ; celles en
           attente partent avec le prochain enregistrement, après le rapport. -->
      <section class="rdlg-attach">
        <div class="rdlg-attach__head">
          <span class="rdlg-attach__title">
            <i class="fa-solid fa-paperclip" aria-hidden="true"></i>
            {{ 'INSPECTION.ATTACH.TITLE' | translate }}
          </span>
          <span class="rdlg-attach__hint">{{ 'INSPECTION.ATTACH.HINT' | translate }}</span>
        </div>

        @if (attachments().length || pending().length) {
          <ul class="rdlg-attach__list">
            @for (a of attachments(); track a.id) {
              <li class="rdlg-attach__item">
                <i [class]="'fa-solid ' + iconOf(a.fileName)" aria-hidden="true"></i>
                <a class="rdlg-attach__name" [href]="a.url" target="_blank" rel="noopener">{{ a.fileName }}</a>
                <span class="rdlg-attach__size">{{ a.sizeBytes | fileSize }}</span>
                <button type="button" class="rdlg-attach__remove" (click)="removeAttachment(a)"
                        [disabled]="saving()" [attr.aria-label]="'INSPECTION.ATTACH.REMOVE' | translate">
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </li>
            }
            @for (f of pending(); track f) {
              <li class="rdlg-attach__item is-pending">
                <i [class]="'fa-solid ' + iconOf(f.name)" aria-hidden="true"></i>
                <span class="rdlg-attach__name">{{ f.name }}</span>
                <span class="rdlg-attach__size">{{ f.size | fileSize }} · {{ 'INSPECTION.ATTACH.PENDING' | translate }}</span>
                <button type="button" class="rdlg-attach__remove" (click)="removePending(f)"
                        [disabled]="saving()" [attr.aria-label]="'INSPECTION.ATTACH.REMOVE' | translate">
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </li>
            }
          </ul>
        }

        <label class="rdlg__btn rdlg-attach__add">
          <i class="fa-solid fa-plus"></i>
          {{ 'INSPECTION.ATTACH.ADD' | translate }}
          <input type="file" class="rdlg-attach__input" [accept]="attachAccept" multiple
                 [disabled]="saving()" (change)="pickFiles($event)">
        </label>
      </section>
    </div>

    <footer class="rdlg__foot">
      <button type="button" class="rdlg__btn" (click)="close()" [disabled]="saving()">
        {{ 'ACTIONS.CANCEL' | translate }}
      </button>
      <button type="button" class="rdlg__btn rdlg__btn--primary"
              [disabled]="saving() || !reportValid" (click)="submit()">
        @if (saving()) { <i class="fa-solid fa-circle-notch fa-spin"></i> }
        {{ 'INSPECTION.MARK_INSPECTED' | translate }}
      </button>
    </footer>
  }
</dialog>
